import styles from './CBComponent.module.css'
import { DSCBComponent, DSTpl } from 'shared-definitions/types'
import { CBAdsControlContext } from 'shared-components/contexts/CBAdsControlContext'
import ComponentTitle from 'shared-components/ui/ComponentTitle'
import NC from 'nc/NC'
import { DSNCAA } from 'types.aa.ds'
import clsx from 'clsx'

interface CBComponentProps {
  data: DSCBComponent<DSNCAA>
  tpl: DSTpl
}

const CBComponent: React.VFC<CBComponentProps> = ({ data, tpl }) => {
  const { voidQuantity } = CBAdsControlContext.useContainer()

  if (data.component.length === voidQuantity) {
    return null
  }

  let newTpl = tpl
  if (data.fullWidth && newTpl === 'home') {
    newTpl = 'home-full-width'
  }

  return (
    <div
      className={clsx(styles.container, {
        [styles.fullWidth]: data.fullWidth,
      })}
    >
      <ComponentTitle header={data.header} />
      {data.component.map((item, index) => (
        <NC key={index} data={item} tpl={newTpl} index={index} />
      ))}
    </div>
  )
}

export default CBComponent
